import { ArrowUpRight, Phone } from "lucide-react";
import { PHONE_DISPLAY, TEL_LINK } from "@/lib/site";
import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  {
    no: "01",
    title: "Call ya WhatsApp kijiye",
    desc: `${PHONE_DISPLAY} par contact kijiye — apni requirement 2 minute mein batayein.`,
  },
  {
    no: "02",
    title: "Free document check",
    desc: "Hum eligibility check karte hain — doorstep ya online, dono options available.",
  },
  {
    no: "03",
    title: "Instant loan sanction",
    desc: "Best offer fast approval ke saath — rates aur tenure aapki marzi se choose kijiye.",
  },
  {
    no: "04",
    title: "Bank transfer",
    desc: "Paisa seedha aapke bank account mein — process complete, sapna shuru.",
  },
];

export const Process = () => (
  <section id="process" className="py-20 sm:py-28 bg-tint/70 border-y border-black/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12 lg:mb-16">
        <div>
          <Eyebrow>04 — Process</Eyebrow>
          <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl tracking-tight text-ink">
            Chaar aasan <em className="italic text-brand">steps</em>.
          </h2>
        </div>
        <a
          data-testid="process-call-cta"
          href={TEL_LINK}
          className="inline-flex items-center gap-2 rounded-full bg-ink text-white px-6 py-3.5 text-sm font-semibold hover:bg-brand transition-colors self-start lg:self-auto"
        >
          <Phone className="w-4 h-4" /> Step 01 abhi shuru kijiye
        </a>
      </Reveal>

      <div>
        {STEPS.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.06}>
            <div
              data-testid={`process-step-${s.no}`}
              className={`group grid grid-cols-12 items-center gap-3 sm:gap-6 py-7 sm:py-9 border-t border-black/10 ${
                i === STEPS.length - 1 ? "border-b" : ""
              }`}
            >
              <span className="col-span-3 sm:col-span-2 font-mono text-3xl sm:text-5xl text-gold font-medium">
                {s.no}
              </span>
              <h3 className="col-span-9 sm:col-span-4 font-display text-xl sm:text-2xl font-medium text-ink">
                {s.title}
              </h3>
              <p className="col-span-10 sm:col-span-5 text-sm sm:text-base text-slate-600 leading-relaxed">
                {s.desc}
              </p>
              <ArrowUpRight className="hidden sm:block col-span-1 w-6 h-6 text-slate-300 group-hover:text-brand group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300 justify-self-end" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
